export default __webpack_public_path__ + "static/media/icon-pwd.dd03ef84.png";